import TemplateBuilder from './template-builder';


export default (di) => {
	di
		.setType({type: TemplateBuilder, name: 'TemplateBuilder', parent: 'PageComponent'})
	;
};
